import { AdminLinkedPageProps } from './admin-linked-page-props';
import { AdminPagePicker } from '../admin-page-picker';
import { ControlText } from '@mint/ui';
import React from 'react';
import styled from 'styled-components';

const Wrapper = styled.div`
  border: 1px solid ${props => props.theme.palette.divider};
  border-radius: 4px;
  display: flex;
  margin: 2rem -0.5rem 0;
  padding: 0.5rem;
  align-items: center;
`;

const Title = styled(ControlText)`
  flex: 1;
`;

export const AdminLinkedPage: React.FunctionComponent<AdminLinkedPageProps> = ({
  onPageSelect,
  title,
}) => {
  return (
    <Wrapper>
      <Title>{title ? title : <i>No Linked Page</i>}</Title>
      <AdminPagePicker onPageSelect={onPageSelect} />
    </Wrapper>
  );
};
